import clsx from 'clsx';
import React, { memo, PropsWithChildren, useEffect, useMemo, useRef, useState } from 'react';
import { Theme } from '@/utils/constants';
import useStyles from '../HomepageContent.styles';

// [Dots removed]: https://authxconsulting.atlassian.net/browse/GEN-1108
import { /* Dots, */ Headings, useInterval } from '../shared';

// [Dots removed]: https://authxconsulting.atlassian.net/browse/GEN-1108
// import { Line } from '../Scrolled/Line';

const Timed = ({
  segments,
  subheading,
  staticHeadline,
  index: forceIndex,
  children,
  theme = Theme.light,
}: PropsWithChildren<Br.PropsWithContentButtons<any>>) => {
  const classes = useStyles({});

  const initDelay = useRef(3000);
  const lastIndex = useMemo(() => segments.length - 1, [segments.length]);

  const [index, setIndex] = useState(0);
  const [delay, setDelay] = useState<number | null>(initDelay.current);

  const play = () => {
    setDelay(initDelay.current);
  };

  const pause = () => {
    setDelay(null);
  };

  useEffect(() => {
    if (forceIndex !== undefined) {
      if (forceIndex === lastIndex) {
        pause();
        setIndex(forceIndex);
        return;
      }

      setIndex(forceIndex);
      play();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [forceIndex]);

  useInterval(() => {
    const nextIndex = index + 1;

    if (segments) {
      setIndex(nextIndex < lastIndex ? nextIndex : 0);
    }
  }, delay);

  useEffect(() => {
    let paused = false;

    const onVisibilityChange = () => {
      if (paused) {
        play();
        paused = false;
        return;
      }

      if (document.hidden && delay !== null) {
        paused = true;
        pause();
      }
    };

    document.addEventListener('visibilitychange', onVisibilityChange);

    return () => document.removeEventListener('visibilitychange', onVisibilityChange);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={classes.elements}>
      <div className={clsx(classes.child, classes.headings)}>
        <Headings
          subheading={subheading}
          staticHeadline={staticHeadline}
          segments={segments.map((s: any) => s.label)}
          index={index}
          theme={theme}
        >
          {children}
        </Headings>
      </div>
      {/* [Dots removed]: https://authxconsulting.atlassian.net/browse/GEN-1108 */}
      {/* <div className={clsx(classes.child, classes.dots, overflowContent && classes.fixedDots)}>
        <div className={classes.line}>
          <Line steps={segments.length} index={index} />
        </div>
        <Dots list={segments.map((s: any) => s.pattern)} index={index} />
      </div> */}
    </div>
  );
};

export default memo(Timed);
